
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgChartsModule } from 'ng2-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptorService } from './core/interceptors/error-interceptor.service';
import { JwtInterceptorService } from './core/interceptors/jwt-interceptor.service';
import { CustomMatPaginatorIntl } from './core/services/customMatPaginatorIntl';
import { AuthGuard } from './core/services/guards/auth.guard';
import { MaintenanceGuard } from './core/services/guards/maintenance.guard';
import { UserComercialGuard } from './core/services/guards/userComercial.guard';
import { UserTypeGuard } from './core/services/guards/userType.guard';
import { LoginAdminComponent } from './modules/login-admin/login-admin.component';
import { MaintenanceComponent } from './modules/maintenance/maintenance.component';
import { CheckEmailComponent } from './modules/resseting-pass/check-email/check-email.component';
import { ResetFormComponent } from './modules/resseting-pass/reset-form/reset-form.component';
import { RessetingPassComponent } from './modules/resseting-pass/resseting-pass.component';
import { SharedModule } from './shared';


registerLocaleData(localeEs);
@NgModule({
  declarations: [
    AppComponent,
    RessetingPassComponent,
    CheckEmailComponent,
    ResetFormComponent,
    MaintenanceComponent,
    LoginAdminComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgChartsModule,
    BrowserAnimationsModule,
    NgxSkeletonLoaderModule,
    
  ],
  providers: [
    AuthGuard,
    UserTypeGuard,
    MaintenanceGuard,
    UserComercialGuard,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptorService,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptorService,
    multi: true
  },
  {
    provide:MatPaginatorIntl,
    useClass: CustomMatPaginatorIntl
  },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
